/**
 * @generated SignedSource<<16129051e76b763eff1974d789c801b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FundsManager_component$data = {
  readonly advisortext: string | null | undefined;
  readonly email: string | null | undefined;
  readonly managercompany: string | null | undefined;
  readonly managername: string | null | undefined;
  readonly phone: string | null | undefined;
  readonly picture: {
    readonly " $fragmentSpreads": FragmentRefs<"ProfilePicture_picture">;
  } | null | undefined;
  readonly " $fragmentType": "FundsManager_component";
};
export type FundsManager_component$key = {
  readonly " $data"?: FundsManager_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"FundsManager_component">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FundsManager_component",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "managername",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "managercompany",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "advisortext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfilePicture",
      "kind": "LinkedField",
      "name": "picture",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProfilePicture_picture"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "type": "FundsManager",
  "abstractKey": null
};

(node as any).hash = "1605903399a9d25e8bbdd14b7f44bde1";

export default node;
